import {   FETCH_ACTIVE_SEASONS,SAVE_SEASON_TEMPLATE,TRIGGER_SEASON,RESET_TEMPLATE_SETTINGS  } from '../../actions'

function getSeasonTemplate(seasons){
       
        const seasonTemplate = {}
      
        seasons.map(function(season) {
      
            const { id,templateReleaseDays,isSeasonSet } = season
            const template = {
                seasonId: id,
                templateReleaseDays,
                isSeasonSet
            }
            seasonTemplate[id] = template
        })
        return seasonTemplate
}
function getSingleSeasonTemplate(season) {
    
    const { id,templateReleaseDays } = season
    const template = {
            seasonId: id,
            templateReleaseDays,
            isSeasonSet:true
        }
    return template
}
export default function seasontemplate (state,action) {   
        const {  payload } = action      
        switch(action.type) {
          
            case FETCH_ACTIVE_SEASONS: {           
                const { data } = payload
                if (data) {                
                    const defaultId = payload.data[0].id
                    const template = getSeasonTemplate(data)
                   
                    return Object.assign({},state,{
                            values: {
                                template,
                                settingsseason:defaultId,
                                initialstate:template
                            },
                            fields: {
                                template,
                                settingsseason:defaultId,
                                initialstate:template
                            }
                        }
                    )
                }
                else {
                    return state
                }
            }
            case SAVE_SEASON_TEMPLATE: {
                const datasaved  = true 
                const savingdata = false
                return  { ...state, 
                    values: {
                             ...state.values,
                             savingdata,
                             datasaved,
                             initialstate:state.values.template         
                           },
                    fields: {
                             ...state.fields,
                             savingdata,
                             datasaved,
                             initialstate:state.values.template  
                           }
                 }
            }
            case TRIGGER_SEASON: {
                const seasontriggered = true 
                const isSettingSeason = false
              
                const seasontemplate  = getSingleSeasonTemplate(payload.data)
               
                const seasonId  = seasontemplate.seasonId
                const { template } = state.values
                template[seasonId] = seasontemplate
               
                return  { ...state, 
                   values: {
                             ...state.values ,
                             seasontriggered,
                             isSettingSeason ,
                             template                          
                           },
                   fields: {
                             ...state.fields,
                             seasontriggered,
                             isSettingSeason,
                             template   
                           }
                 }
               
            }
            case RESET_TEMPLATE_SETTINGS:{
             
                const { initialstate } = state.values
              
                return  { ...state, 
                    values: {
                             ...state.values,
                             participants:initialstate,
                             templatereset:true
                           },
                    fields:{
                             ...state.fields,
                             participants:initialstate,
                             templatereset:true
                           }
                 }
            }
            default: return state
        }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/forms/seasontemplate.js